module.exports = __webpack_public_path__ + "img/device06.bb2725ac.png";